import { render, staticRenderFns } from "./error-content.vue?vue&type=template&id=5e2b23ba"
import script from "./error-content.vue?vue&type=script&lang=js"
export * from "./error-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2b23ba')) {
      api.createRecord('5e2b23ba', component.options)
    } else {
      api.reload('5e2b23ba', component.options)
    }
    module.hot.accept("./error-content.vue?vue&type=template&id=5e2b23ba", function () {
      api.rerender('5e2b23ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/error-page/error-content.vue"
export default component.exports